export enum UserRegistrationType {
    Vendor,
    Free,
    Fleet
}
